import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import content from '../../content';
import richText from '../../richText';
import './About.css';

const { about } = content;

function About() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, offset: 80 });
  }, []);

  const hasLists = about.lists.length > 0;

  return (
    <section id={about.id} className="about-section">
      <div className="about-container">
        {about.label && (
          <div className="section-label" data-aos="fade-up">{about.label}</div>
        )}
        <h2 className="section-heading" data-aos="fade-up" data-aos-delay="50">
          {about.heading}
        </h2>

        <div className={`about-grid ${hasLists ? '' : 'about-grid-single'}`}>
          <div className="about-bio" data-aos="fade-right" data-aos-delay="100">
            {about.paragraphs.map((paragraph, i) => (
              <p key={i}>{richText(paragraph)}</p>
            ))}
          </div>

          {hasLists && (
            <div className="about-right" data-aos="fade-left" data-aos-delay="150">
              {about.lists.map((list) => (
                <div className="about-card" key={list.title}>
                  <h3>{list.title}</h3>
                  <div className="skills-grid">
                    {list.items.map((item) => (
                      <span key={item} className="skill-badge">{item}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default About;
